<template>
  <div>
    <table-list
        ref="table"
        idKey="planId"
        :listConfig="listConfig"
        :apis="apis"
        :createFrom="fromConfig"
        :searchConfig="searchConfig"
        :btn-config="btnConfig"
        @handleBtn="handleBtn"
        @cellDblclick="cellDblclick"
        :btnConfig="btnConfig | filterBtnsRole($route)"
    >
    </table-list>
    <!-- 确认到达 -->
    <from-list
        ref="arrive"
        :fromConfig="arriveConfig"
        @confirm="arriveConfirm">
    </from-list>
    <from-list
        ref="arrive"
        :fromConfig="arriveConfig"
        @confirm="arriveConfirm">
    </from-list>
    <from-list ref="EditALL" :fromConfig="allConfigList" @confirm="allConfirm"/>
    <from-list ref="remark" :fromConfig="remarkConfig" @confirm="remarkConfirm"/>
    <detail-list ref="detail" :detailConfig="detailConfig" :detailApi="apis.detail">
      <div
          style="padding: 0 104px"
          slot="box_operation_record"
          slot-scope="data"
      >
        <el-table
            style="width: 99.9%"
            header-align="center"
            align="center"
            :data="data.from.value"
        >
          <el-table-column
              header-align="center"
              align="center"
              prop="operation"
              label="操作"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="operationTime"
              label="操作时间"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="operatorName"
              label="操作人"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="money"
              label="结算金额"
          >
          </el-table-column>
        </el-table>
      </div>
      <div style="padding: 0 104px;" slot="box_operation_remark" slot-scope="data">
        <el-table style="width: 99.9%" header-align="center" align="center" :data="data.from.value">
          <el-table-column header-align="center" align="center" prop="date" label="时间"></el-table-column>
          <el-table-column header-align="center" align="center" prop="operatorName" label="备注人"></el-table-column>
          <el-table-column header-align="center" align="center" prop="remark" label="备注内容"></el-table-column>
        </el-table>
      </div>
      <div style="padding: 0 104px" slot="box_operation_orderRunTrackList" slot-scope="data">
        <el-table style="width: 99.9%" header-align="center" align="center" :data="data.from.value">
          <el-table-column header-align="center" align="center" prop="runstateName" label="操作"/>
          <el-table-column header-align="center" align="center" prop="createTime" label="时间"/>
          <el-table-column header-align="center" align="center" prop="orientation" label="地址"/>
          <el-table-column header-align="center" align="center" prop="remark" label="备注内容"/>
          <el-table-column header-align="center" align="center" prop="remark" label="照片">
            <template slot-scope="{row}">
              <div style="display: inline-grid;">
                <el-image v-if="row.images" v-for="item in row.images.split(',')"
                          :src="item"
                          :preview-src-list="[item]"
                />
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </detail-list>
  </div>
</template>

<script>
import config from "./config/transit.config";
import {road, carType, supplier} from "@/api/public";
import {transitEditAll} from "@/api/OrderRun";

export default {
  data() {
    return {
      carTypeList: [],
      roadList: [],
      supplierList: [],
      searchConfig: [],
      arriveConfig: [],
      remarkConfig: [],
      allConfigList: [],
      ...config(),
    };
  },
  created() {
    this.createConfig();
  },
  methods: {
    cellDblclick(row) {
      this.$refs.detail.getDtail(row.planId);
    },
    handleBtn(key, list) {
      if (list.length !== 1) this.$error("请选择一条发车计划");
      if (key === "arrive") {
        this.arriveConfig = this.createArrive();
      } else if (key === "remark") {
        this.remarkConfig = this.createRemark();
        this.$refs[key].open(null, {planId: list[0].planId});
        return
      } else if (key === 'EditALL') {
        this.allConfigList = this.allConfig();
      }
      this.$refs[key].open(list[0], {planId: list[0].planId});
    },
    async allConfirm(data) {
      const params = this.$params(this.allConfigList);
      if (params.driver) {
        params.driverId = params.driver.driverId
      }
      const [res] = await this.$ajax(transitEditAll, {...params, ...data});
      if (res.data) {
        this.$refs.EditALL.close();
        this.$refs.table.getList();
      }
    },
    async arriveConfirm(data) {
      const params = this.$params(this.arriveConfig);
      const [res] = await this.$ajax(this.apis.arrive, {...params, ...data});
      if (res) {
        this.$refs.arrive.close();
        this.$refs.table.getList();
      }
    },
    async remarkConfirm(data) {
      const params = this.$params(this.remarkConfig);
      const [res] = await this.$ajax(this.apis.SetRemark, {...params, ...data});
      if (res.data) {
        this.$refs.remark.close();
        this.$refs.table.getList();
      }
    },
    createConfig() {
      Promise.all([road(), carType(), supplier()]).then(
          ([road, carType, supplier]) => {
            this.roadList = road.data.map((item) => ({
              ...item,
              label: item.name,
              value: item.roadId,
            }));
            this.carTypeList = carType.data.map((item) => ({
              ...item,
              label: item.carType,
              value: String(item.carId),
            }));
            this.supplierList = supplier.data.map((item) => ({
              ...item,
              label: item.name,
              value: item.supplierId,
            }));
            this.searchConfig = this.createSearch(this.roadList);
            this.allConfig = this.createAllFrom(this.roadList, this.carTypeList, this.supplierList)
          }
      );
    },
  },
};
</script>

<style lang="less" scoped>
</style>
